import http from './http-common'; // Ensure http is correctly configured with axios or your preferred HTTP client

interface User {
  id: number;
  name: string;
  email: string;
  // Add other relevant fields here
}

class UserDataService {
  // Pobierz wszystkich użytkowników
  async getAll(): Promise<User[] | undefined> {
    return await http.get<User[]>("/users").then((res) => res.data);
  }

  // Pobierz użytkownika po ID
  async getById(userId: number): Promise<User | undefined> {
    return await http.get<User>(`/users/${userId}`).then((res) => res.data);
  }

  // Tworzenie nowego użytkownika lub aktualizacja istniejącego
  async save(userData: Partial<User>): Promise<User | undefined> {
    try {
      if (userData.id) {
        // Aktualizacja istniejącego użytkownika
        const response = await http.put<User>(`/user/${userData.id}`, userData);
        return response.data;
      } else {
        // Tworzenie nowego użytkownika
        const response = await http.post<User>("/user", userData);
        return response.data;
      }
    } catch (error) {
      this.handleError(error);
      return undefined;
    }
  }

  // Zmiana hasła przez użytkownika (wymaga starego hasła)
  async changePassword(oldPassword: string, newPassword: string): Promise<any> {
    try {
      console.log("Changing user password...");
  
      const response = await http.put(
        `/user/password`,
        { oldPassword, newPassword },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error: any) {
      console.error("Failed to change password:", error);
  
      // Return backend error message if available
      if (error.response && error.response.data) {
        throw new Error(error.response.data); // Forward message to UI
      }
      throw new Error("Wystąpił błąd podczas zmiany hasła."); // Fallback message
    }
  }
  
  // Resetowanie hasła przez administratora (bez starego hasła)
  async resetPasswordByAdmin(userId: number, newPassword: string): Promise<any> {
    try {
      console.log(`Admin resetting password for user ID: ${userId} pass: ${newPassword}`);
      
      const response = await http.put(`/admin/user/${userId}/password`,  { "newPassword": newPassword } );
      return response.data;
    } catch (error) {
      console.error("Failed to reset password by admin:", error);
      this.handleError(error); // Log and handle errors
    }
  }

  // Usunięcie użytkownika
  async delete(userId: number): Promise<boolean> {
    try {
      await http.delete(`/user/${userId}`); // Wysyłamy żądanie DELETE do serwera
      return true; // Zwracamy true w przypadku powodzenia
    } catch (error) {
      this.handleError(error); // Obsługa błędu
      return false; // Zwracamy false, jeśli wystąpił błąd
    }
  }

  // Obsługa błędów API
  private handleError(error: any): void {
    console.error("API call failed: ", error);
    if (error.response) {
      console.error("HTTP Status: ", error.response.status);
      console.error("Response Data: ", error.response.data);
    } else if (error.request) {
      console.error("No response received: ", error.request);
    } else {
      console.error("Request setup error: ", error.message);
    }
    throw error; // Rzucamy wyjątek dalej
  }
}

const userDataServiceInstance = new UserDataService();
export default userDataServiceInstance;
